// from https://github.com/sindresorhus/query-string/blob/master/index.js
const parseQueryString = (str) => {
  // Create an object with no prototype
  // https://github.com/sindresorhus/query-string/issues/47
  const ret = Object.create(null);

  if (typeof str !== 'string') {
    return ret;
  }
  // eslint-disable-next-line
  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return ret;
  }

  str.split('&').forEach((param) => {
    const parts = param.replace(/\+/g, ' ').split('=');
    // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37
    let key = parts.shift();
    let val = parts.length > 0 ? parts.join('=') : undefined;

    key = decodeURIComponent(key);

    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    try {
      val = val === undefined ? null : decodeURIComponent(val);
    } catch (error) {
      val = null;
    }

    if (ret[key] === undefined) {
      ret[key] = val;
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      ret[key] = [ret[key], val];
    }
  });

  // temporary fix
  if ('tr' in ret) {
    ret.tr = {
      buy: 'vendita',
      vendita: 'vendita',
      vendite: 'vendita',
      affitti: 'affitti',
      affitto: 'affitti',
      rent: '"affitti',
    }[ret.tr] || 'vendita';
  }
  const regeExpOnlyNumbers = new RegExp(/^[0-9]+$/g);

  if (ret.priceMin) {
    const matchNumbers = ret.priceMin.match(regeExpOnlyNumbers);
    if (!matchNumbers) {
      ret.priceMin = ret.priceMin.replace(/[^0-9]+/g, '');
    }
  }
  if (ret.priceMax) {
    const matchNumbers = ret.priceMax.match(regeExpOnlyNumbers);
    if (!matchNumbers) {
      ret.priceMax = ret.priceMax.replace(/[^0-9]+/g, '');
    }
  }
  if (ret.mqMax) {
    const matchNumbers = ret.mqMax.match(regeExpOnlyNumbers);
    if (!matchNumbers) {
      ret.mqMax = ret.mqMax.replace(/[^0-9]+/g, '');
    }
  }
  if (ret.mqMin) {
    const matchNumbers = ret.mqMin.match(regeExpOnlyNumbers);
    if (!matchNumbers) {
      ret.mqMin = ret.mqMin.replace(/[^0-9]+/g, '');
    }
  }
  if (ret.poi) {
    try {
      ret.poi = JSON.parse(ret.poi);
    } catch (error) {
      console.log('Error trying get qs from poi >>:');
    }
  }
  if (Array.isArray(ret.sortType) && ret.sortType.length > 0) {
    [ret.sortType] = ret.sortType;
  }
  return ret;
};

export default parseQueryString;
